import React from "react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "components/Graphs/Tabs";
import {
  launchableContentTabsListClassName,
  type LaunchableContentTabProps,
} from "components/Launchables/DeployRedesign/shared/content/tabs/LaunchableContentTab";
import { AgentDeployBanner } from "./shared";

interface PhysicalAISkinProps extends LaunchableContentTabProps {
  skillFolderUrl: string;
  overview: React.ReactNode;
  details: React.ReactNode;
}

export const PhysicalAISkin: React.FC<PhysicalAISkinProps> = ({
  activeTab,
  onActiveTabChange,
  leadingTabs = [],
  trailingTabs = [],
  skillFolderUrl,
  overview,
  details,
}) => (
  <div className="flex w-full flex-col gap-4">
    <AgentDeployBanner skillFolderUrl={skillFolderUrl} />
    <Tabs
      value={activeTab}
      onValueChange={onActiveTabChange}
      defaultValue={activeTab ? undefined : "overview"}
    >
      <TabsList variant="line" className={launchableContentTabsListClassName}>
        {leadingTabs.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value}>
            {tab.label}
          </TabsTrigger>
        ))}
        <TabsTrigger value="overview">Overview</TabsTrigger>
        <TabsTrigger value="details">Details</TabsTrigger>
        {trailingTabs.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value}>
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {leadingTabs.map((tab) => (
        <TabsContent key={tab.value} value={tab.value}>
          {tab.content}
        </TabsContent>
      ))}
      <TabsContent value="overview">{overview}</TabsContent>
      <TabsContent value="details">{details}</TabsContent>
      {trailingTabs.map((tab) => (
        <TabsContent key={tab.value} value={tab.value}>
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  </div>
);
